var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "tr",
    [
      _c(
        "td",
        {
          staticClass: "boss-center boss-table-4-link-cell",
          attrs: { "data-test": "date" },
        },
        [
          _vm._v("\n    " + _vm._s(_vm.applicationDate) + "\n    "),
          _c("div", { attrs: { "data-test": "time" } }, [
            _vm._v("\n      " + _vm._s(_vm.applicationTime) + "\n    "),
          ]),
        ]
      ),
      _vm._v(" "),
      _c("td", { staticClass: "boss-center" }, [
        _c("span", { attrs: { "data-test": "user-id" } }, [
          _vm._v("ID:" + _vm._s(_vm.entry.userId)),
        ]),
        _vm._v(" "),
        _vm.entry.isDuplicatedEntries
          ? _c("span", [
              _c("br"),
              _vm._v(" "),
              _c(
                "span",
                {
                  directives: [
                    {
                      name: "tooltip",
                      rawName: "v-tooltip",
                      value: {
                        content:
                          "同一セミナーに複数回応募している場合に表示されます。",
                      },
                      expression:
                        "{ content: '同一セミナーに複数回応募している場合に表示されます。'}",
                    },
                  ],
                  staticClass: "boss-status-label",
                  attrs: { "data-test": "duplicate" },
                },
                [_vm._v("重複応募\n      ")]
              ),
            ])
          : _vm._e(),
        _vm._v(" "),
        _c("div", { attrs: { "data-test": "member-name" } }, [
          _vm._v("\n      " + _vm._s(_vm.memberName) + "\n    "),
        ]),
      ]),
      _vm._v(" "),
      _c(
        "td",
        {
          staticClass: "is-boss-only-pc",
          attrs: { "data-test": "seminar-id" },
        },
        [
          _vm._v("\n    セミナーID:" + _vm._s(_vm.entry.seminar.id) + "\n    "),
          _c("div", { attrs: { "data-test": "seminar-name" } }, [
            _vm._v("\n      " + _vm._s(_vm.seminarName) + "\n    "),
          ]),
        ]
      ),
      _vm._v(" "),
      _c("message-icon-information", {
        attrs: { message: _vm.entry.message, "is-entry": false },
      }),
      _vm._v(" "),
      _c("td", { staticClass: "boss-center is-boss-only-pc" }, [
        _c("span", { attrs: { "data-test": "status" } }, [
          _vm._v(_vm._s(_vm.statusName)),
        ]),
      ]),
      _vm._v(" "),
      _c("td", { staticClass: "pega-remarks-label is-boss-only-pc" }, [
        _c("span", { attrs: { "data-test": "remarks" } }, [
          _vm._v(_vm._s(_vm.entry.remarks)),
        ]),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }